import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ExtendedInfoIcon } from '../../../shared/svg/components';
import { getPriceText } from '../../../utils/currencyFormatter';
import { TranslationUtility } from '../../../utilities/TranslationUtility';
import IsNullOrUndefined from '../../../utils/ObjectUtils';
import { PriceUtility } from '../../../utilities/PriceUtility';
import FormatVat from '../../../utils/VatFormatter';

const SummaryFeaturePrinting = ({
 categoryName, feature, disabled, includesPrices,
}) => {
  const { settings, isPublic, vat } = useSelector(state => state.configurator);

  // eslint-disable-next-line no-restricted-globals
  const isPublicTextFeature = () => isNaN(feature.price) && isPublic;

  if (disabled) return null;

  return (
    <div className="summary-feature-printing">
      <div className="category-name">{categoryName}</div>
      <div className="container-image-texts">
        <div className="image-mask">
          <div className="image-container">
            <img src={`${settings.thumbs_base_url}/${feature.thumb}`} alt="" />
          </div>
        </div>
        <div className="feature-text-container">
          <div className="feature-title-name-container">
            <div className="feature-title">
              {TranslationUtility.GetFormattedMessageForUI('ui-feature-option', 'Opción')}{` ${feature.order}`}
            </div>
            <div className="feature-name">{TranslationUtility.GetFormattedMessageForFeatureName(feature)}</div>
            {feature.description.length > 0 && (
              <div className="container-icon-description-extended">
                <div className="icon-container"><ExtendedInfoIcon className="icon" /></div>
                <div className="description">
                  {TranslationUtility.GetFormattedMessageForFeatureDescription(feature)}
                </div>
              </div>
            )}
          </div>
          {(includesPrices && !isPublicTextFeature()) ? (
            <>
              {!vat.vat_breakdown_disabled ? (
                <div className="feature-price">
                  {PriceUtility.getFeatureFormattedPrice(feature, vat)}
                </div>
            ) : null}
              {!vat.vat_breakdown_disabled ? (
                <div className="feature-price">
                  {PriceUtility.getFeatureFormattedVatValue(feature, vat)}
                </div>
            ) : null}
              <div className="feature-price">
                {getPriceText(PriceUtility.calculateFeaturePriceIncVat(feature, vat), true)}
              </div>
            </>
          ) : (
            <div className="feature-price">
              {PriceUtility.getPublicFeatureFormattedPrice(feature, vat)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

SummaryFeaturePrinting.propTypes = {
  categoryName: PropTypes.string.isRequired,
  feature: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    thumb: PropTypes.string,
    order: PropTypes.number,
    hasPrice: PropTypes.bool,
    price: PropTypes.string,
  }).isRequired,
  disabled: PropTypes.bool.isRequired,
  includesPrices: PropTypes.bool.isRequired,
};

export default SummaryFeaturePrinting;
